import { mountApp } from './App.js'
import './styles/reset.css'
import './styles/tokens.css'
import './styles/layout.css'
import './styles/blockly-overrides.css'
import './styles/code-overlay.css'
import './styles/play-mode.css'
import './styles/template-selector.css'
import './styles/sprite-picker.css'
import './styles/share-modal.css'

mountApp(document.getElementById('app'))
